import { createContext } from "react";

export interface FormControlContextValue {
  id: string;
  errorId?: string;
  legendId?: string;
  hasError?: boolean;
  isValid?: boolean;
}

export const FormControlContext = createContext<FormControlContextValue | null>(
  null,
);
